import { listLayoutProps } from '~components/InfoPage/propTypes';
import React from 'react';
import _ from 'lodash';
import { stateEnums } from '~utils/enums';
import StatePageAccordion, {
  AccordionGroup,
} from '~components/common/Accordion/StatePageAccordion';
import Markdown from '~components/common/Markdown';
import {
  whatAreTheVoterRegistrationDeadlines,
  canIRegisterOnline,
  canIRegisterOnElectionDay,
} from '~utils/faqAnswersRegister';
import { canIHaveABallotMailedToMe } from '~utils/faqAnswersAbsentee';
import {
  canIVoteEarly,
  whereDoIVote,
  whatDoINeedToBringToThePolls,
  canIUseStudentId,
} from '~utils/faqAnswersInPersonVoting';

export default function StudentVoters({ state }) {
  const stateData = _.keyBy(state.nodes, 'field_type');
  const stateName = state.fieldValue;
  const stateCode = stateEnums.find(
    (e) => e.option.toLowerCase() === stateName.toLowerCase()
  ).value;

  return (
    <AccordionGroup>
      <StatePageAccordion heading='What are the voter registration deadlines?'>
        <Markdown
          content={whatAreTheVoterRegistrationDeadlines(
            stateData,
            stateName,
            stateCode
          )}
        />
      </StatePageAccordion>
      <StatePageAccordion heading='Can I register to vote online?'>
        <Markdown
          content={canIRegisterOnline(stateData, stateName, stateCode)}
        />
      </StatePageAccordion>
      <StatePageAccordion heading='Can I vote early?'>
        <Markdown content={canIVoteEarly(stateData, stateName, stateCode)} />
      </StatePageAccordion>
      <StatePageAccordion
        heading={`Does ${stateName} offer same day registration?`}
      >
        <Markdown
          content={canIRegisterOnElectionDay(
            stateData,
            stateName,
            stateCode,
            false
          )}
        />
      </StatePageAccordion>
      <StatePageAccordion heading='Where do I vote?'>
        <Markdown content={whereDoIVote(stateData, stateName, stateCode)} />
      </StatePageAccordion>
      <StatePageAccordion heading='What ID do I need to bring with me when I vote?'>
        <Markdown content={whatDoINeedToBringToThePolls(stateData)} />
      </StatePageAccordion>
      <StatePageAccordion heading='Can I use a student ID to vote?'>
        <Markdown content={canIUseStudentId(stateData)} />
      </StatePageAccordion>
      <StatePageAccordion heading='How do I vote by absentee ballot?'>
        <Markdown
          content={canIHaveABallotMailedToMe(stateData, stateName, stateCode)}
        />
      </StatePageAccordion>
    </AccordionGroup>
  );
}

StudentVoters.propTypes = listLayoutProps;
